import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Account } from 'interface'
import axiosClient from 'utils/axiosClient'

const initialState: { list: Account[] } = {
  list: [],
}

export const getAccounts = createAsyncThunk('Account/getAccounts', async () => {
  const { data } = await axiosClient.get('/api/system')
  return data
})
export const getAccount = createAsyncThunk(
  'Account/getAccount',
  async (id: string | number) => {
    const { data } = await axiosClient.get('/api/system/' + id)
    return data
  }
)

export const AccountSlice = createSlice({
  name: 'Account',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAccounts.fulfilled, (state, { payload }) => {
      state.list = payload
    })
    builder.addCase(getAccount.fulfilled, (state, { payload }) => {
      const index = state.list.findIndex((f) => f.id === payload.id)
      if (index >= 0) {
        state.list.splice(index, 1, payload)
      } else {
        state.list.push(payload)
      }
    })
  },
})

export const AccountAction = AccountSlice.actions

export const AccountReducer = AccountSlice.reducer
